import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import { compareOrderAdminService } from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const compareOrderAdminContext = createContext({
  missing_orders: {},
  setMissing_orders: () => {},
  to_date: "",
  setTo_date: () => {},
  from_date: "",
  setFrom_date: () => {},
  create_invoice: null,
  setCreate_invoice: () => {},
  handleGetCompareOrder: () => {},
});

const CompareOrderAdminContext = ({ children, isUser = false }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [missing_orders, setMissing_orders] = useState({});
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [create_invoice, setCreate_invoice] = useState(false);

  // Handle Get Compare Order Method
  const handleGetCompareOrder = async (event) => {
    event?.preventDefault();

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      create_invoice,
      ...(to_dateVal && { to_date: to_dateVal }),
      ...(from_dateVal && { from_date: from_dateVal }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await compareOrderAdminService(objData);
      if (status === 200) {
        setMissing_orders(data.missing_orders);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <compareOrderAdminContext.Provider
      value={{
        missing_orders,
        setMissing_orders,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        create_invoice,
        setCreate_invoice,
        handleGetCompareOrder,
      }}
    >
      {children}
    </compareOrderAdminContext.Provider>
  );
};

export default CompareOrderAdminContext;
